import React, {useEffect, useState} from "react";
import apiGet from "../../shared/api/apiGet";
import {ENDPOINT_PAYMENT_INIT} from "../../shared/consts/apiConsts";
import PaymentForm from "../../shared/BookingPage/PaymentForm/PaymentForm";
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';

const stripePromise = loadStripe('pk_live_D0k4MylfWogLnDAYOacyui0d', {
  stripeAccount: 'acct_1D24fWBbh1yc4sPj'
});

//https://docs.stripe.com/stripe-js/react#elements-props-stripe
const PaymentPage = () => {

  const [init, setInit] = useState(false);
  const [config, setConfig] = useState(false);

  useEffect(() => {
    apiGet(ENDPOINT_PAYMENT_INIT)
      .then((data) => {
        setInit(true);
        setConfig(data);
      })
  }, [])


  if (!init) {
    return null;
  }

  return <Elements stripe={stripePromise} >
    <div className="booking bookingPage">
      <div className="container--">
        <div className="booking__wrap">
          <div>

            <div className="booking-card active">
              <div className="booking-card__wrap">
                <div className="booking-card__title">
                  <h4>{config.title}</h4>
                  <div className="booking-card__totals__amount">
                    <p className={'h4'}>{config.outbound.price}</p>
                  </div>
                </div>
                <div className="booking-card__features">
                  <div className="booking-card__feature">
                    <div className="booking-card__feature__title">
                      <p>Date</p>
                    </div>
                    <div className="booking-card__feature__content">
                      <p>
                        {config.outbound.pickup_date}
                      </p>
                    </div>
                  </div>
                  <div className="booking-card__feature">
                    <div className="booking-card__feature__title">
                      <p>Pick-up</p>
                    </div>
                    <div className="booking-card__feature__content">
                      <p>
                        {config.outbound.pickup}
                      </p>
                    </div>
                  </div>
                  <div className="booking-card__feature">
                    <div className="booking-card__feature__title">
                      <p>Drop-off</p>
                    </div>
                    <div className="booking-card__feature__content">
                      <p>
                        {config.outbound.dropoff}
                      </p>
                    </div>
                  </div>


                  {!!config.inbound && <>
                    <div className="booking-card__title">
                      <h4>Return trip</h4>
                      <div className="booking-card__totals__amount">
                        <p className={'h4'}>{config.inbound.price}</p>
                      </div>
                    </div>
                    <div className="booking-card__feature">
                      <div className="booking-card__feature__title">
                        <p>Date</p>
                      </div>
                      <div className="booking-card__feature__content">
                        <p>
                          {config.inbound.pickup_date}
                        </p>
                      </div>
                    </div>
                    <div className="booking-card__feature">
                      <div className="booking-card__feature__title">
                        <p>Pick-up</p>
                      </div>
                      <div className="booking-card__feature__content">
                        <p>
                          {config.inbound.pickup}
                        </p>
                      </div>
                    </div>
                    <div className="booking-card__feature">
                      <div className="booking-card__feature__title">
                        <p>Drop-off</p>
                      </div>
                      <div className="booking-card__feature__content">
                        <p>
                          {config.inbound.dropoff}
                        </p>
                      </div>
                    </div>
                  </>}
                  <div className="booking-card__feature">
                    <div className="booking-card__feature__title">
                      <p>Passengers</p>
                    </div>
                    <div className="booking-card__feature__content">
                      <p>{config.outbound.pax}</p>
                    </div>
                  </div>



                  {config.extras && <>
                    <div className="booking-card__title">
                      <h4>Extras & Fees</h4>
                    </div>

                    {config.extras.map((extra, index) => {
                      return <div
                        key={index}
                        className="booking-card__feature booking-card__feature--between">
                        <div className={'div'}>
                          <div className="booking-card__feature__title">
                            <p>{extra.name} x {extra.quantity}</p>
                          </div>
                        </div>
                        <div className="booking-card__feature__price">
                          <p>{extra.total}</p>
                        </div>
                      </div>
                    })}
                  </>}

                  <div className="booking-card__totals">
                    <div className={'booking-card__totals__row'}>
                      <div className="booking-card__totals__label">
                        <p className={'h4'}>Subtotal</p>
                      </div>
                      <div className="booking-card__totals__amount">
                        <p className={'h4'}>{config.subtotal}</p>
                      </div>
                    </div>
                    <div className={'booking-card__totals__row'}>
                      <div className="booking-card__totals__label">
                        <p className={'h4'}>Taxes & Fees</p>
                      </div>
                      <div className="booking-card__totals__amount">
                        <p className={'h4'}>{config.tax}</p>
                      </div>
                    </div>
                    <div className={'booking-card__totals__row'}>
                      <div className="booking-card__totals__label">
                        <p className={'h4'}>Total</p>
                      </div>
                      <div className="booking-card__totals__amount">
                        <p className={'h4'}>{config.total}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <PaymentForm
            config={config}
          />
        </div>
      </div>
    </div>
  </Elements>

}

export default PaymentPage;
